import {createRedux} from '../../../redux/factories/common/reduxFactory';

const {actionTypes, actions} = createRedux([
    'loadDashboard',
    'downloadUserManual'
]);


const INIT_STATE = {
    loading: false,
    totalUsers: 1,
    totalTemplates: 1,
    totalDocuments: 1,
    limitUsers: 10,
    limitTemplates: 3,
    limitDocuments: 100,
    documentsByTemplates: {},
    recentDocuments: [],
};

const dashboardReducers = (state = INIT_STATE, action) => {
    if (action.type === actionTypes['loadDashboardSuccess']) {
        const {
            users, templates, documents, limitUsers, limitTemplates,
            limitDocuments, documentsByTemplates, recentDocuments
        } = action.payload.data;
        return {
            ...state,
            loading: false,
            totalUsers: users,
            totalTemplates: templates,
            totalDocuments: documents,
            documentsByTemplates,
            limitUsers,
            limitTemplates,
            limitDocuments,
            recentDocuments,
        };
    } else if (action.type === actionTypes['loadDashboard']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['loadDashboardFailed']) {
        return {...state, loading: false, error: 'Error while getting system usage information.'};
    } else if (action.type === actionTypes['downloadUserManualSuccess']) {
        return {...state, loading: false};
    } else if (action.type === actionTypes['downloadUserManual']) {
        return {...state, loading: true};
    } else if (action.type === actionTypes['downloadUserManualFailed']) {
        return {...state, loading: false, error: 'Error while getting the user manual.'};
    } else {
        return {...state, loading: false};
    }
};

export {actions, actionTypes, dashboardReducers};
